import commonGetters from '@/store/data/common/getters'
import { find, isNil, includes } from 'lodash'
import { MEDIA_CONVERSION_TYPE, MEDIA_CAMPAIGN_TYPE } from '@/utils/constants'

const getters = {
    getIsConversionEmpty: state => () => {
        const getIsConversionEmpty = find(state.list, item => includes(MEDIA_CONVERSION_TYPE, item.jsonKey.type))
        return isNil(getIsConversionEmpty)
    },

    getIsCampaignEmpty: state => () => {
        const getIsCampaignEmpty = find(
            state.list,
            item => includes(MEDIA_CAMPAIGN_TYPE, item.jsonKey.type) && item.label !== 'Clicked' && item.label !== 'Exposed'
        )
        return isNil(getIsCampaignEmpty)
    }
}

export default { ...commonGetters, ...getters }
